import { AnyAction, Dispatch } from 'redux';
import { getWebSocketClient } from '../../../../infra/websocket/websocket';
import { setWsClient } from '../../../../store/selectors/global.selector';
import { AppState } from '../../../../store/store';
import { ThunkResult } from '../ThunkResult';

export const instantiateWebsocket = (): ThunkResult<any> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    const ws = getWebSocketClient(dispatch);
    ws.activate();
    dispatch(setWsClient(ws));
  };
};
